import React from "react";
import { useTranslation } from "react-i18next";
import { FieldLayout } from "@/pages/ContactsPage/Components/FieldLayout";
import { FormInput, FormTextArea } from "@/shared/Components";
import type { FieldProps } from "@/pages/ContactsPage/types";

export const Hobbies: React.FC<FieldProps> = ({ index }) => {
  const { t } = useTranslation();

  return (
    <FieldLayout>
      <FormInput
        name={`hobbies.${index}.hobbyType.name`}
        placeholder={t("contactsPage.activities.hobby")}
      />
      <FormTextArea name={`hobbies.${index}.about`} placeholder={t("common.about")} />
    </FieldLayout>
  );
};
